<template>
    <div>
        <el-dialog align-center v-model="state.dialogVisible" :title="title || t('improveDetail.title')" width="800" draggable>
            <div class="userAdd_man">
                <el-form ref="ruleForm" label-width="auto" :model="state.form" :rules="rules" class="userFrom">
                    <el-col v-if="currentTask.title && currentTask.title.length > 0" :span="12" style="margin-bottom: 20px;">
                        <el-form-item :label="t('improveDetail.taskName')" prop="title">
                            {{ currentTask.title }}
                        </el-form-item>
                    </el-col>
                    <el-col v-if="currentTask.score && currentTask.score.length > 0" :span="12" style="margin-bottom: 20px;">
                        <el-form-item :label="t('improveDetail.score')" prop="score">
                            {{ currentTask.score }}
                        </el-form-item>
                    </el-col>
                    <el-col v-if="currentTask.staff && currentTask.staff.length > 0" :span="12" style="margin-bottom: 20px;">
                        <el-form-item :label="t('improveDetail.staffLimit')" prop="staff">
                            {{ currentTask.staff > 0 ? currentTask.staff : t('improveDetail.unlimited') }}
                        </el-form-item>
                    </el-col>
                    <el-col v-if="currentTask.start_time && currentTask.start_time.length > 0" :span="12" style="margin-bottom: 20px;">
                        <el-form-item :label="t('taskSpecial.startTime')" prop="start_time">
                            {{ formatDisplayDateTime(currentTask.start_time) }}
                        </el-form-item>
                    </el-col>
                    <el-col v-if="currentTask.end_time && currentTask.end_time.length > 0" :span="12" style="margin-bottom: 20px;">
                        <el-form-item :label="t('taskSpecial.endTime')" prop="end_time">
                            {{ formatDisplayDateTime(currentTask.end_time) }}
                        </el-form-item>
                    </el-col>
                    <el-col v-if="currentTask.description && currentTask.description.length > 0" :span="24" style="margin-bottom: 20px;">
                        <el-form-item :label="t('improveDetail.taskDesc')" prop="end_time">
                            {{ currentTask.description }}
                        </el-form-item>
                    </el-col>

                    <el-col v-if="fileList.length > 0" :span="24">
                        <el-form-item :label="t('improveDetail.taskMaterial')">
                            <hc-oss-image-list :value="currentTask.url" />
                        </el-form-item>
                    </el-col>

                    <el-divider></el-divider>
                    <el-col :span="24">
                        <el-form-item :label="t('improveDetail.submitter')">
                            {{ state.form.real_name }}
                        </el-form-item>
                    </el-col>
                    <el-col :span="24" style="margin-bottom: 20px;">
                        <el-form-item :label="t('improveDetail.submitPhotos')">
                            <hc-oss-image-list :value="state.form.material_url" />
                        </el-form-item>
                    </el-col>
                    <el-col :span="24" style="margin-bottom: 20px;">
                        <el-form-item :label="t('improveDetail.submitContent')">
                            {{ state.form.note }}
                        </el-form-item>
                    </el-col>

                    <el-col :span="24" style="margin-bottom: 20px;">
                        <el-form-item :label="t('improveDetail.auditComment')" prop="comment">
                            {{ state.form.comment }}
                        </el-form-item>
                    </el-col>
                    <el-col :span="24" style="margin-bottom: 20px;">
                        <el-form-item :label="t('taskSubmit.auditStatus')" prop="status">
                            {{ statusMap[state.form.status] }}
                        </el-form-item>
                    </el-col>

                </el-form>
            </div>
            <template #footer>
                <div class="dialog-footer">
                    <el-button @click="state.dialogVisible = false">{{ t('improveDetail.close') }}</el-button>
                </div>
            </template>
        </el-dialog>
    </div>
</template>

<script setup>
import {
    onMounted,
    reactive,
    ref,
    defineEmits,
    defineProps,
    defineExpose,
    toRaw
} from "vue";
import { ElMessage } from "element-plus";
import { auditApi } from "@/api/task/special";
import { detailApi } from "@/api/task/submitRecord";
import { formatDisplayDateTime } from "@/utils/dateTime.js";
import { usePageI18n } from "@/composables/usePageI18n.js";

const statusMap = ref({})

const applyLabels = () => {
    statusMap.value = {
        2: t('taskSubmit.pass'),
        3: t('taskSubmit.reject')
    };
};
const { t } = usePageI18n(applyLabels);

const emit = defineEmits([]);
const props = defineProps({
    title: {
        type: String,
        default: "",
    },
    row: {
        type: Object,
        default: () => { },
    },
});

const rules = reactive({});

const fileList = ref([])
const getImgArr = (str) => {
    if (!str || str.length === 0) {
        return []
    }
    return JSON.parse(str).map(i => i.url)
}
const state = reactive({
    dialogVisible: false,
    form: {
        "id": 0,
        "replied_by": 0,
        "replied_name": "",
        "comment": "",
        "status": 0,

    }
});

const currentTask = ref({})

const getDetailInfo = (row = {}) => {
    if (row?.id) {
        const params = {
            id: row.id
        }
        detailApi(params).then(res => {
            if (res.code == 200) {
                fileList.value = JSON.parse(res.data.specialTasks.url ?? '[]')
                currentTask.value = res.data.specialTasks ?? {}
                state.form = {
                    "id": row.id,
                    "replied_by": res.data.userSpecialTasks.repliedBy,
                    "replied_name": res.data.userSpecialTasks.repliedName,
                    "comment": row.comment,
                    "material_url": res.data.userSpecialTasks.materialUrl,
                    "real_name": row.real_name,
                    "note": row.note,
                    "status": row.status ?? 2
                }
            }
        })

    } else {
        state.form.id = 0
    }
}

const open = (row) => {
    state.dialogVisible = true;
    getDetailInfo(toRaw(row))
};

const ruleForm = ref(null)
const submit = () => {
    ruleForm.value.validate((valid) => {
        if (valid) {
            const { user } = JSON.parse(localStorage.getItem("user"));
            const params = JSON.stringify({
                ...toRaw(state.form),
                "replied_by": user.users.id,
                "replied_name": user.users.realName,
            })
            auditApi(params).then(res => {
                if (res?.code === 200) {
                    ElMessage.success(t('improveDetail.opSuccess'))
                    state.dialogVisible = false
                    state.form = {
                        "id": 0,
                        "replied_by": 0,
                        "replied_name": "",
                        "comment": "",
                        "status": 0
                    }
                    emit('refresh')
                }
            })
        } else {
            return false;
        }
    });
};

onMounted(() => {
    applyLabels();
});

defineExpose({ open, state });
</script>

<style lang="less" scoped>
.userAdd_man {
    min-height: 200px;
    max-height: 600px;
    overflow: auto;
    padding: 0 30px;
}

.userFrom {
    display: flex;
    flex-wrap: wrap;
}

.el-form-item {
    margin-bottom: 0;
}

.tree_man {
    padding: 0 30px;
}

.record-img {
    width: 160px;
    height: 160px;
    border-radius: 6px;
    object-fit: cover;
    margin-left: 10px;
}
</style>
